/**
 * SROC — Smoothed Price Rate-of-Change.
 *
 * Migrado do Silverlight (GraficoDePrata/Formulas/FMLMomentum.cs, classe
 * FML.SROC). Painel próprio:
 *
 *   EMA13 = EMA(C, ME)
 *   ROC   = (EMA13 − REF(EMA13,N)) / REF(EMA13,N) * 100
 *   ROCMA = MA(ROC, M)     ← `Visible = M != 0` no engine (M=0 ⇒ não plota)
 *   zero  = 0              ← linha tracejada (SetAttrs "StyleDash")
 *
 * ROCMA é calculado SEMPRE (paridade com o oráculo, inclusive com M=0, em que
 * MA(x,0) é a média cumulativa); quem respeita o `Visible` é a série
 * (SROCSeries só desenha a linha quando M ≠ 0). Paridade provada em
 * __tests__/sroc.silverlight.test.js.
 */
import { ema, ref, sub, div, mul, ma } from "./silverlightDsl";
import { SROC as defaultOptions } from "./defaultOptionsForComputation";

export default function () {
  let options = defaultOptions;

  function calculator(data) {
    const { me, period, m } = options;
    const close = data.map((d) =>
      Number.isFinite(d.close) ? d.close : Number.NaN,
    );

    const emaClose = ema(close, me);
    const prev = ref(emaClose, period);
    const roc = mul(div(sub(emaClose, prev), prev), 100);
    const rocma = ma(roc, m);

    return roc.map((v, i) => {
      const rocOut = Number.isFinite(v) ? v : undefined;
      const rocmaOut = Number.isFinite(rocma[i]) ? rocma[i] : undefined;
      if (rocOut === undefined && rocmaOut === undefined) return undefined;
      return { roc: rocOut, rocma: rocmaOut };
    });
  }

  calculator.undefinedLength = function () {
    const { period } = options;
    // O EMA do engine não tem warm-up NaN (seed = f[0]); só o REF(·,N) atrasa.
    return Math.max(0, period);
  };

  calculator.options = function (x) {
    if (!arguments.length) {
      return options;
    }
    options = { ...defaultOptions, ...x };
    return calculator;
  };

  return calculator;
}
